import { Component, Input } from '@angular/core';
import { IStoreSelectionStore } from '../../../models/common.models';

@Component({
  selector: 'app-store-selection-map',
  templateUrl: './store-selection-map.component.html',
  styleUrls: ['./store-selection-map.component.scss'],
  standalone: false,
})
export class StoreSelectionMapComponent {

  @Input()
  stores!: IStoreSelectionStore[];

  redirect(store: string): void {
    window.location.href = `${window.location.origin}/${store}`;
  }
}
